import { useContext, useEffect, useRef, useState } from "react";
import {
  FaAward,
  FaBatteryFull,
  FaGlobe,
  FaShieldAlt,
  FaUsers,
  FaHandshake,
  FaStoreAlt,
  FaUserTie,
  FaBuilding,
  FaBriefcase,
  FaStore,
  FaUser,
  FaMousePointer,
  FaUserCheck,
  FaSignInAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { CurrencyContext } from "../features/context/CurrencyContext";
import { base_url } from "../utils/axiosConfig";
import { AuthContext } from "../context";

const hasRepeatedDigits = (price) => {
  if (!price) return true;
  return /(\d)\1{4,}/.test(String(price));
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [promotional, setPromotional] = useState([]);
  const [vendorProduct, setVendorProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const testimonialSliderRef = useRef(null);
  const { convertPrice, getCurrencySymbol } = useContext(CurrencyContext);
  const { openAccountModal } = useContext(AuthContext);
  const [memberPackages, setMemberPackages] = useState([]);
  const courseDetail = [
    {
      id: "1",
      course: "Digital Emergency Health Kit",
      imageSrc: "/popular/dehk.jpeg",
      price: "300",
      category: "dek",
    },
    {
      id: "15",
      course: "Digital & Physical Emergency Health Kit",
      imageSrc: "/popular/dmehk.png",
      profession: "Learn React Native with Node.js",
      price: "300",
      category: "dmek",
    },
    {
      id: "4",
      course: "Diagnosis",
      imageSrc: "/popular/diagnosis.jpeg",
      profession: "Learn TensorFlow with SQL",
      price: "1500",
      category: "diagnosis",
    },
    {
      id: "14",
      course: "Quick Health Checkup",
      imageSrc: "/popular/qhc.jpeg",
      profession: "Learn Bokeh with Python",
      price: "300",
      category: "qhc",
    },
    {
      id: "3",
      course: "Express Medical Test",
      imageSrc: "/popular/xmt.jpeg",
      profession: "Scikit with Python Development",
      price: "1499",
      category: "emt",
    },
    {
      id: "5",
      course: "Body Recharge Station",
      imageSrc: "/popular/brs.png",
      profession: "Platform-as-a-Service",
      price: "1800",
      category: "brs",
    },
  ];
  const [selectedButton, setSelectedButton] = useState("dek");
  const mobileDevelopment = courseDetail.filter(
    (name) => name.category === "dmek",
  );
  const webDevelopment = courseDetail.filter((name) => name.category === "dek");
  const dataScience = courseDetail.filter(
    (name) => name.category === "diagnosis",
  );
  const cloudComputing = courseDetail.filter((name) => name.category === "qhc");
  const expressMedical = courseDetail.filter((name) => name.category === "emt");
  const bodyRecharge = courseDetail.filter((name) => name.category === "brs");

  let selectedNames = [];
  if (selectedButton === "dmek") {
    selectedNames = mobileDevelopment;
  } else if (selectedButton === "dek") {
    selectedNames = webDevelopment;
  } else if (selectedButton === "diagnosis") {
    selectedNames = dataScience;
  } else if (selectedButton === "qhc") {
    selectedNames = cloudComputing;
  } else if (selectedButton === "emt") {
    selectedNames = expressMedical;
  } else if (selectedButton === "brs") {
    selectedNames = bodyRecharge;
  }

  const nameElements = selectedNames.map((name, index) => (
    <div id="Courses" key={index} className="shadow-lg rounded-xl group flex">
      {/* <div className="py-5 lg:py-0 flex flex-col"> */}
      <a href={`/services/${name.id}`} className="cursor-pointer">
        <div className="overflow-hidden rounded-lg bg-gray-100">
          <img
            src={name.imageSrc}
            alt={name.course}
            width={700}
            height={700}
            className="h-full w-full object-cover object-center"
          />
        </div>
        {/* <div className="p-4 flex flex-col justify-between gap-5 flex-1"> */}
        {/* <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <p className="w-[60%] font-normal text-gray-900 break-words">
                {name.course}
              </p>
            </div>
          </div> */}
        {/* <div className="flex justify-between border-solid border-2 rounded-md p-2">
            <p>12 Classes</p>
            <div className="flex flex-row space-x-4">
              <div className="flex">
                <Image
                  src={withBasePath("/images/courses/account.svg")}
                  width={18}
                  height={20}
                  alt="circle"
                />
                <p className="text-lightgrey ml-1">120</p>
              </div>
              <div className="flex">
                <Image
                  src={withBasePath("/images/courses/Star.svg")}
                  width={18}
                  height={20}
                  alt="star"
                />
                <p className="ml-1">4.5</p>
              </div>
            </div>
          </div> */}
        {/* </div> */}
      </a>
      {/* </div> */}
    </div>
  ));

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    pauseOnHover: false,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  const banners = [
    { url: "/banner/banner21.jpeg" },
    { url: "/banner/banner22.jpeg" },
    { url: "/banner/banner23.jpeg" },
    { url: "/banner/dehk.jpeg" },
    { url: "/banner/dmek.png" },
    { url: "/banner/diagnosis1.png" },
    { url: "/banner/brs1.png" },
    { url: "/banner/brs2.png" },
    { url: "/banner/brs3.png" },
    { url: "/banner/brs4.jpeg" },
  ];

  const companies = [
    {
      imgSrc: "/company/1a.png",
    },
    {
      imgSrc: "/company/1b.png",
    },
    {
      imgSrc: "/company/1c.png",
    },
    {
      imgSrc: "/company/1d.png",
    },
    {
      imgSrc: "/company/2.png",
    },
    {
      imgSrc: "/company/3.png",
    },
    {
      imgSrc: "/company/4.png",
    },
    {
      imgSrc: "/company/5.png",
    },
    {
      imgSrc: "/company/6.png",
    },
    {
      imgSrc: "/company/7.png",
    },
    {
      imgSrc: "/company/8.png",
    },
    {
      imgSrc: "/company/9.png",
    },
    {
      imgSrc: "/company/10.png",
    },
    {
      imgSrc: "/company/11.jpeg",
    },
    {
      imgSrc: "/company/12.jpeg",
    },
    {
      imgSrc: "/company/13.jpeg",
    },
  ];

  useEffect(() => {
    let start = 0;
    const end = 500;

    const interval = setInterval(() => {
      start++;
      setCount(start);
      if (start === end) clearInterval(interval);
    }, 10);

    return () => clearInterval(interval);
  }, []);

  const isValidProduct = (product) => {
    const price =
      product?.price?.amount ?? product?.variations?.[0]?.price?.amount;

    return price && !hasRepeatedDigits(price);
  };

  const hasProducts = (category) => {
    const check = (items = []) => items.some(isValidProduct);

    if (check(category?.products)) return true;

    return category?.subCategories?.some(
      (sub) =>
        check(sub?.products) ||
        sub?.subSubCategories?.some(
          (ss) =>
            check(ss?.products) ||
            ss?.subSubSubCategories?.some((sss) => check(sss?.products)),
        ),
    );
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const [catRes, testRes, venRes, packRes] = await Promise.all([
          fetch(
            `${base_url}product/getCategory?page=1&limit=100&sortingColumn=createdAt&sortingOrder=asc`,
          ),
          fetch(`${base_url}product/getTestimonialVideo`),
          fetch(`${base_url}v1/vendor/getVendorProductForWebsite`),
          fetch(`${base_url}v1/package/fetchAllpackage`),
        ]);

        if (!catRes.ok || !testRes.ok || !venRes.ok || !packRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const catData = await catRes.json();
        const testData = await testRes.json();
        const venData = await venRes.json();
        const packData = await packRes.json();

        const allProducts =
          catData?.data?.flatMap((category) => {
            // Skip inactive categories
            if (!category?.isActive) return [];

            const catId = category?._id;

            return (
              category?.subCategories
                ?.filter((sub) => sub?.isActive) // Skip inactive subcategories
                ?.flatMap((sub) => {
                  const subId = sub?._id;

                  // Products directly in this sub-category
                  const directProducts = (sub?.products || [])
                    .filter((product) => product?.isActive) // Skip inactive products
                    .map((product) => ({
                      ...product,
                      categoryId: catId,
                      subCategoryId: subId,
                      subSubCategoryId: null,
                    }));

                  // Products from sub-sub-categories
                  const subSubProducts = (sub?.subSubCategories || [])
                    .filter((ss) => ss?.isActive)
                    .flatMap((ss) => {
                      const ssId = ss?._id;

                      const ssDirectProducts = (ss?.products || [])
                        .filter((product) => product?.isActive)
                        .map((product) => ({
                          ...product,
                          categoryId: catId,
                          subCategoryId: subId,
                          subSubCategoryId: ssId,
                        }));

                      // Products from sub-sub-sub-categories
                      const sssProducts = (ss?.subSubSubCategories || [])
                        .filter((sss) => sss?.isActive)
                        .flatMap((sss) => {
                          const sssId = sss?._id;

                          return (sss?.products || [])
                            .filter((product) => product?.isActive)
                            .map((product) => ({
                              ...product,
                              categoryId: catId,
                              subCategoryId: subId,
                              subSubCategoryId: ssId,
                              subSubSubCategoryId: sssId,
                            }));
                        });

                      return [...ssDirectProducts, ...sssProducts];
                    });

                  return [...directProducts, ...subSubProducts];
                }) || []
            );
          }) || [];

        setCategories(catData?.data || []);
        setProducts(allProducts.filter(isValidProduct));
        setTestimonials(testData?.data?.testimonials || []);
        setPromotional(testData?.data?.promotionalsVideo || []);
        setVendorProduct(venData?.data || []);
        setMemberPackages(packData.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const settings2 = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 800, settings: { slidesToShow: 1 } },
    ],
  };

  const faqs = [
    {
      q: "What is LifeOnPlus?",
      a: "LifeOnPlus is a complete digital healthcare ecosystem offering medical products, diagnostics, wellness services, and smart health technology.",
    },
    {
      q: "How does the Global Digital Health Smart Card work?",
      a: "It stores your medical records digitally. Doctors can scan the QR code to access your health history instantly during emergencies.",
    },
    {
      q: "What services can I access on LifeOnPlus?",
      a: "Health products, lab tests, doctor consultations, wellness therapies, insurance, and digital health tools — all in one place.",
    },
    {
      q: "Is my health data secure?",
      a: "Yes. We use bank-level encryption and HIPAA-compliant standards to protect your personal health information.",
    },
    {
      q: "Can I become a partner or franchise?",
      a: "Yes. We offer channel partner, virtual partner, and franchise opportunities across India and globally.",
    },
    {
      q: "Do you offer home services?",
      a: "Yes. Many diagnostic tests, wellness therapies, and consultations are available with home collection or doorstep delivery.",
    },
  ];

  const testimonial = [
    {
      profession: "Tamil Actor",
      name: "Sharath Kumar",
      imgSrc: "/testimonials/user-1.jpeg",
      detail: "Innovative Product",
    },
    {
      profession: "Member of Lok Sabha",
      name: "Annasaheb Shankar Jolle",
      imgSrc: "/testimonials/user-2.jpeg",
      detail:
        "Highly advanced Medical & Digital Health Technology, I have seen the demo & appriciated , getting aligned with this company",
    },
    {
      profession:
        "BBM - Founder & Chairman of United Medicare Pte Ltd, Singapore ",
      name: "Robin NG",
      imgSrc: "/testimonials/user-3.jpeg",
      detail: "Very Good Medical Technology and Devices",
    },
    {
      profession: "Former Education Minister",
      name: "Suresh Kumar",
      imgSrc: "/testimonials/user-4.jpeg",
      detail: "Excellent Medical Health Technology",
    },

    {
      profession: "Actress, Bangalore",
      name: "Ragini Dwivedi",
      imgSrc: "/testimonials/user-5.jpeg",
      detail:
        " Having Spent Many Years on Research and Development on Innovative Medical Technology. Finally we got a very good product for Human Being. I Wish Mr. Rajanikanth and His Team great Success.",
    },
    {
      profession: "National University of Singapore",
      name: "Cynthia Chan",
      imgSrc: "/testimonials/user-6.jpeg",
      detail: "New Medical & Innovative Idea",
    },
  ];

  const TestimonialSkeleton = () => {
    return (
      <>
        <div className="m-4">
          <div
            role="status"
            className="max-w-md animate-pulse overflow-hidden rounded-lg bg-white p-8"
          >
            <svg
              className="w-20 h-20 mx-auto text-gray-200 my-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 18"
            >
              <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
            </svg>
            <div className="h-2 w-28 mx-auto bg-gray-200 rounded-full dark:bg-gray-700"></div>
            <div className="h-2 w-48 mx-auto bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] my-5"></div>

            <div className="h-2 w-24 mx-auto bg-gray-200 rounded-full dark:bg-gray-700 mb-10"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </>
    );
  };

  const bannerSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    adaptiveHeight: false, // set true if images have very different aspect ratios
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-14 w-14 border-4 border-[#47b250] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return <p className="text-center text-red-600 mt-10">Error: {error}</p>;
  }

  return (
    <>
      {/* Custom Styles for Uniform Height */}
      <style>{`
        .testimonial-slider .slick-list {
          height: auto !important;
        }

        .testimonial-slider .slick-track {
          display: flex !important;
          align-items: stretch;
        }

        .testimonial-slider .slick-slide {
          height: 100% !important;
          display: flex !important;
        }

        .testimonial-slider .slick-slide > div {
          height: 100% !important;
          width: 100% !important;
        }

        /* Optional: Equal height cards */
        .testimonial-card {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
      `}</style>

      {/* Banner */}
      <div className="w-full overflow-hidden">
        <Slider {...bannerSettings}>
          {banners.map((b, i) => (
            <div key={i}>
              <div className="border-[3px] border-[#35A93E] h-full">
                <img src={b.url} className="w-full h-full object-contain" />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Trust Bar */}
      <div className="bg-white py-4 border-b">
        <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-center gap-8 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <FaShieldAlt /> 100% Secure Payment
          </div>
          <div className="flex items-center gap-2">
            <FaAward /> ISO Certified
          </div>
          <div className="flex items-center gap-2">
            <FaUsers /> 10,000+ Happy Customers
          </div>
        </div>
      </div>
      <div className="container-fluid mx-auto max-w-7xl my-5">
        <div>
          <Slider {...settings}>
            {companies.map((item, i) => (
              <div key={i}>
                <img
                  src={item.imgSrc}
                  alt={item.imgSrc}
                  width={100}
                  height={50}
                  // className='w-auto'
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* About Company */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6">About LifeOnPlus</h2>
            <p className="text-gray-600 leading-relaxed text-lg">
              We are pioneers in Digital Health Technology, combining innovative
              medical devices with advanced digital solutions to make healthcare
              accessible, affordable, and intelligent for everyone.
            </p>
            <div className="mt-8 grid grid-cols-3 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold text-[#35A93E]">10+</div>
                <div className="text-sm text-gray-500">Verticals</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#35A93E]">12+</div>
                <div className="text-sm text-gray-500">Countries</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#35A93E]">110</div>
                <div className="text-sm text-gray-500">Partners</div>
              </div>
            </div>
          </div>
          <div className="border-[3px] border-[#35A93E] h-full">
            <img
              src="/banner24.jpeg"
              alt="About Us"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
      {/* Why Choose Us */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            Why Choose LifeOnPlus?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <FaGlobe size={50} />,
                title: "Global Standards",
                desc: "ISO certified & HIPAA compliant technology",
              },
              {
                icon: <FaBatteryFull size={50} />,
                title: "Advanced Technology",
                desc: "Latest medical devices with digital integration",
              },
              {
                icon: <FaShieldAlt size={50} />,
                title: "Secure & Reliable",
                desc: "Your health data is protected with bank-level security",
              },
              {
                icon: <FaUsers size={50} />,
                title: "Expert Support",
                desc: "24/7 dedicated customer care & technical support",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="text-center p-8 rounded-3xl border hover:shadow-xl transition"
              >
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 flex items-center justify-center text-[#35A93E] bg-green-50 rounded-2xl group-hover:scale-110 transition-transform">
                    {item.icon}
                  </div>
                </div>
                <h3 className="font-semibold text-lg mb-3">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ================= Membership Plans ================= */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="text-[#35A93E] text-sm font-semibold uppercase tracking-wider">
              Membership
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-2">
              Choose Your Membership Plan
            </h2>

            <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
              Select a healthcare membership that best suits your needs and
              enjoy exclusive digital healthcare benefits.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {memberPackages?.map((plan) => (
              <div
                key={plan._id}
                className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition overflow-hidden border border-gray-100"
              >
                {/* Image */}
                <img
                  src={plan.images?.[0]}
                  alt={plan.name}
                  className="w-full h-64 object-contain"
                />

                <div className="p-3">
                  {/* Name */}

                  {/* Price */}
                  <div className="mt-2 flex items-center justify-between">
                    <h3 className="text-base font-semibold">{plan.name}</h3>
                    <span className="text-sm font-bold text-[#35A93E]">
                      ₹{plan.price.totalAmount}/{" "}
                      <span className="text-sm text-gray-500">
                        {plan.duration_days} Days
                      </span>
                    </span>
                  </div>

                  {/* Description */}
                  <p className="text-xs text-gray-600 mt-3 line-clamp-2">
                    {plan.description}
                  </p>

                  {/* Features */}
                  <ul className="mt-1 space-y-1">
                    {plan.features.map((feature, index) => (
                      <li
                        key={index}
                        className="flex items-start gap-2 text-xs text-gray-700"
                      >
                        <span className="text-[#35A93E]">✔</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Common CTA */}

          <div className="mt-10 bg-white rounded-2xl border border-green-100 p-6 shadow-sm flex flex-col lg:flex-row items-center justify-between gap-5">
            <div>
              <h3 className="text-lg font-semibold">
                Ready to Join LifeOnPlus?
              </h3>

              <p className="text-gray-600 text-sm mt-2">
                To purchase any membership plan, first register or log in using
                the
                <span className="font-semibold text-[#35A93E]"> Account </span>
                button available in the website header. Once logged in, you can
                select your preferred membership and complete the purchase.
              </p>
            </div>

            <button
              onClick={openAccountModal}
              className="bg-[#35A93E] hover:bg-green-700 text-white px-8 py-3 rounded-lg transition whitespace-nowrap"
            >
              Register / Login
            </button>
          </div>
        </div>
      </section>

      {/* ================= AI Healthcare Services (Coming Soon) ================= */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="inline-block bg-orange-100 text-orange-600 px-4 py-1 rounded-full text-sm font-semibold">
              🚀 Launching Soon
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-4">
              AI-Powered Healthcare Services
            </h2>

            <p className="text-gray-600 mt-3 max-w-3xl mx-auto">
              We're introducing intelligent AI healthcare solutions to help
              members receive faster guidance, smarter recommendations, and
              enhanced digital healthcare experiences.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-center">
            {/* Left Side */}
            <div>
              <div className="space-y-5">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center text-2xl">
                    🤖
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg">
                      AI Healthcare Assistant
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      Website & WhatsApp chatbot providing 24×7 health-related
                      assistance.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center text-2xl">
                    📋
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg">
                      AI Prescription Assistant
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      AI-assisted prescription suggestions based on symptoms and
                      medical history.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center text-2xl">
                    🧠
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg">
                      AI Health Recommendations
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      Personalized health insights, wellness guidance, and
                      preventive care recommendations.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center text-2xl">
                    🩺
                  </div>

                  <div>
                    <h4 className="font-semibold text-lg">AI Body Screening</h4>

                    <p className="text-gray-600 text-sm mt-1">
                      AI-powered body screening with analysis of multiple vital
                      health parameters for early health insights.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-xl border border-gray-200">
                <img
                  src="/ai-healthcare-coming-soon.png"
                  alt="AI Healthcare Services"
                  className="w-full"
                />
              </div>

              <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full font-semibold shadow-lg">
                Launching Soon
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= How It Works ================= */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold">How LifeOnPlus Works</h2>

            <p className="text-gray-600 mt-4">
              Get started in just a few simple steps.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-8 text-center">
            {[
              {
                no: "01",
                title: "Register",
                desc: "Create your LifeOnPlus account.",
              },
              {
                no: "02",
                title: "Complete Profile",
                desc: "Add your healthcare information securely.",
              },
              {
                no: "03",
                title: "Choose Membership",
                desc: "Select a suitable healthcare plan.",
              },
              {
                no: "04",
                title: "Access Services",
                desc: "Book healthcare services anytime.",
              },
              {
                no: "05",
                title: "Stay Healthy",
                desc: "Track and manage your digital health.",
              },
            ].map((step, index) => (
              <div
                key={index}
                className="relative bg-white rounded-2xl shadow-md p-4 hover:shadow-xl transition"
              >
                <div className="w-12 h-12 rounded-full bg-[#35A93E] text-white flex items-center justify-center mx-auto text-lg font-bold mb-3">
                  {step.no}
                </div>

                <h3 className="font-bold text-base mb-3">{step.title}</h3>

                <p className="text-gray-600 text-xs">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= Account Access ================= */}
      <section className="py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <span className="text-[#35A93E] text-sm font-semibold uppercase tracking-wider">
              Get Started
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-2">
              Access Your LifeOnPlus Account
            </h2>

            <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto mt-3">
              Click the <strong>Account</strong> button in the top-right corner
              to register or log in as a Member, Partner, Corporate, Vendor,
              Franchise, Director, or End User.
            </p>
          </div>

          {/* Steps */}
          <div className="grid md:grid-cols-3 gap-4 mb-6">
            {[
              {
                icon: <FaMousePointer />,
                title: "Click Account",
                desc: "Open the Account menu from the header.",
              },
              {
                icon: <FaUserCheck />,
                title: "Select Role",
                desc: "Choose your preferred account type.",
              },
              {
                icon: <FaSignInAlt />,
                title: "Register / Login",
                desc: "Complete registration or sign in.",
              },
            ].map((step) => (
              <div
                key={step.no}
                className="bg-white border border-gray-200 rounded-xl p-4 flex items-start gap-4 hover:shadow-sm transition"
              >
                <div className="w-10 h-10 rounded-full bg-[#35A93E] text-white flex items-center justify-center font-semibold flex-shrink-0">
                  {step.icon}
                </div>

                <div>
                  <h3 className="text-base font-semibold text-gray-900">
                    {step.title}
                  </h3>

                  <p className="mt-1 text-sm text-gray-600 leading-5">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Roles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              {
                title: "Member",
                icon: <FaUsers />,
                desc: "Purchase healthcare products, manage memberships, and access exclusive member benefits.",
                color: "#02BE0F",
                bg: "#e9f9ee",
              },
              {
                title: "Channel Partner",
                icon: <FaHandshake />,
                desc: "Expand your business by promoting LifeOnPlus products and earning attractive commissions dedicated area.",
                color: "#0d6efd",
                bg: "#e7f1ff",
              },
              {
                title: "Franchise",
                icon: <FaStoreAlt />,
                desc: "Own and operate a LifeOnPlus franchise while delivering healthcare services locally.",
                color: "#8b5cf6",
                bg: "#f3e8ff",
              },
              {
                title: "Channel Partner Plus",
                icon: <FaUserTie />,
                desc: "Unlock premium partnership benefits with higher rewards, incentives, and business revenue sharing.",
                color: "#ff9800",
                bg: "#fff4e5",
              },
              {
                title: "Corporate",
                icon: <FaBuilding />,
                desc: "Corporate Employee wellness solutions for businesses , industries, and professionals.",
                color: "#6f42c1",
                bg: "#f3e8ff",
              },
              {
                title: "Director",
                icon: <FaBriefcase />,
                desc: "Manage partner networks, oversee operations, and drive regional business growth.",
                color: "#343a40",
                bg: "#f5f5f5",
              },
              {
                title: "Vendor",
                icon: <FaStore />,
                desc: "Sell healthcare products through our marketplace and manage your online business.",
                color: "#20c997",
                bg: "#e6fffa",
              },
              {
                title: "End User",
                icon: <FaUser />,
                desc: "Explore healthcare products, wellness services, and digital health solutions with ease.",
                color: "#6c757d",
                bg: "#f8f9fa",
              },
            ].map((role, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-4 hover:shadow-md hover:border-[#35A93E] transition-all"
              >
                {/* Icon + Title */}
                <div className="flex items-center gap-3 mb-2">
                  <div
                    className="w-6 h-6 rounded-lg flex items-center justify-center text-sm flex-shrink-0"
                    style={{
                      backgroundColor: role.bg,
                      color: role.color,
                    }}
                  >
                    {role.icon}
                  </div>

                  <h4 className="font-semibold text-gray-900 text-[15px] leading-5">
                    {role.title}
                  </h4>
                </div>

                {/* Description */}
                <p className="text-xs text-gray-600 leading-6">{role.desc}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-8">
            <button
              onClick={openAccountModal}
              className="bg-[#35A93E] hover:bg-[#2d9436] text-white px-8 py-3 rounded-lg font-medium transition"
            >
              Register / Login
            </button>

            <p className="text-sm text-gray-500 mt-3">
              Opens the Account window where you can choose your role and
              continue.
            </p>
          </div>
        </div>
      </section>

      {/* Popular Services - 3 Items Per Row */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900">
            Our Popular Services
          </h2>
          <p className="text-gray-600 mt-3">
            Innovative health solutions for a better life
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Digital Emergency Health Kit",
              desc: "Instant access to medical records & emergency support anywhere",
              img: "/services-images/dehk.jpeg",
              link: "/services/1",
            },
            {
              title: "Digital & Medical Emergency Kit",
              desc: "Advanced health monitoring with real-time alerts and SOS",
              img: "/services-images/dmek.png",
              link: "/services/15",
            },
            {
              title: "Diagnosis Services",
              desc: "Accurate medical testing with instant digital reports",
              img: "/services-images/diagnosis1.jpeg",
              link: "/services/4",
            },
            {
              title: "Quick Health Checkup",
              desc: "Comprehensive body health assessment in minutes",
              img: "/services-images/qhc1.jpeg",
              link: "/services/14",
            },
            {
              title: "Express Medical Test",
              desc: "Fast & reliable diagnostic services at your convenience",
              img: "/services-images/emt2.png",
              link: "/services/3",
            },
            {
              title: "Body Recharge Station",
              desc: "Advanced wellness and recovery solutions",
              img: "/services-images/brs1.jpeg",
              link: "/services/5",
            },
          ].map((service, index) => (
            <div
              key={index}
              onClick={() => navigate(service.link)}
              className="group bg-white border border-gray-100 rounded-3xl overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-60 bg-gray-100 relative overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-3">
                <h3 className="font-semibold text-xl text-gray-900 mb-2 line-clamp-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-2">
                  {service.desc}
                </p>
                <div className="text-[#35A93E] font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
                  Explore Now →
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== Explore All Services Button ===== */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => navigate("/services")}
            className="bg-[#35A93E] hover:bg-[#2d9436] text-white px-8 py-3 rounded-xl font-medium transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
          >
            Explore All Services
            <span>→</span>
          </button>
        </div>
      </div>

      {promotional.length > 0 && (
        <></>
        // <div className="py-10">
        //   <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-10">
        //     Promotional Videos
        //   </h2>

        //   <div className="max-w-screen-2xl mx-auto py-6 px-4">
        //     <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
        //       {promotional.map((video, index) => (
        //         <div
        //           key={index}
        //           onClick={() => setSelectedVideo(video)}
        //           className="relative cursor-pointer border-2 border-[#35A93E] rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
        //         >
        //           {/* Thumbnail */}
        //           <img
        //             src={"/footerLogo.png"}
        //             alt="video thumbnail"
        //             className="w-full h-56 object-cover"
        //           />

        //           {/* Play icon overlay */}
        //           <div className="absolute inset-0 flex items-center justify-center bg-black/30">
        //             <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center">
        //               ▶
        //             </div>
        //           </div>
        //         </div>
        //       ))}
        //     </div>
        //   </div>
        // </div>
      )}

      {testimonials.length > 0 && (
        <></>
        // <div className="py-10">
        //   <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-10">
        //     Testimonials Videos
        //   </h2>

        //   <div className="max-w-screen-2xl mx-auto py-6 px-4">
        //     <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
        //       {testimonials.map((video, index) => (
        //         <div
        //           key={index}
        //           onClick={() => setSelectedVideo(video)}
        //           className="relative cursor-pointer border-2 border-[#35A93E] rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
        //         >
        //           {/* Thumbnail */}
        //           <img
        //             src={"/footerLogo.png"}
        //             alt="video thumbnail"
        //             className="w-full h-56 object-cover"
        //           />

        //           {/* Play icon overlay */}
        //           <div className="absolute inset-0 flex items-center justify-center bg-black/30">
        //             <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center">
        //               ▶
        //             </div>
        //           </div>
        //         </div>
        //       ))}
        //     </div>
        //   </div>
        // </div>
      )}

      {/* Modal */}
      {selectedVideo && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4"
          onClick={() => setSelectedVideo(null)} // click on overlay closes modal
        >
          <div
            className="relative w-full max-w-3xl bg-black rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()} // prevent click inside video container from closing
          >
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-3 right-3 z-10 w-10 h-10 flex items-center justify-center bg-black/50 text-white text-2xl rounded-full hover:bg-black/70 transition"
            >
              ✕
            </button>

            <video
              src={selectedVideo}
              controls
              autoPlay
              className="w-full max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}

      {/* Categories */}
      {/* <div className="max-w-screen-2xl mx-auto py-10 px-4">
        <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-8">
          Categories
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
          {categories.map((cat) => {
            const enabled = hasProducts(cat);

            return (
              <div
                key={cat._id}
                onClick={
                  enabled
                    ? () =>
                        navigate(`/category/${cat._id}`, {
                          state: { category: cat },
                        })
                    : undefined
                }
                className={`relative border rounded-lg p-4 text-center ${
                  enabled ? "cursor-pointer hover:shadow-md" : "opacity-60"
                }`}
              >
                <img
                  src={cat?.images?.[0]}
                  className="h-[100px] w-full object-contain mb-2"
                />
                <p className="text-sm font-medium">{cat.categoryName}</p>

                {!enabled && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-lg">
                    <span className="text-white font-semibold text-sm">
                      Coming Soon
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div> */}

      <section
        id="testimonial-section"
        className="bg-[#fcf5ef] py-5  mt-5 md:py-5"
      >
        <div className="mx-auto px-4">
          <div className="flex flex-col sm:flex-row gap-5 justify-between sm:items-center">
            <h2 className="text-xl sm:text-xl md:text-3xl lg:text-4xl font-semibold mb-3 md:mb-4">
              Testimonial
            </h2>
            {/* <button className="bg-transparent cursor-pointer hover:bg-primary text-primary font-semibold hover:text-white py-3 px-6 border border-primary hover:border-transparent rounded-sm duration-300 whitespace-nowrap">
              Give Your Review
            </button> */}
          </div>

          <p className="text-lg font-medium mb-3 max-w-2xl">
            What others say about lifeonplus.
          </p>

          <div className="testimonial-slider">
            <Slider {...settings2}>
              {loading
                ? Array.from({ length: 3 }).map((_, i) => (
                    <TestimonialSkeleton key={i} />
                  ))
                : testimonial.map((items, i) => (
                    <div key={i} className="px-3">
                      <div className="testimonial-card bg-white p-4 md:p-10 rounded-2xl shadow-sm flex flex-col min-h-[300px]">
                        <div className="flex justify-center mb-3">
                          <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-white shadow-md bg-white flex items-center justify-center">
                            <img
                              src={items.imgSrc}
                              alt={items.name}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        </div>

                        {/* Content */}
                        <div className="flex-1 flex flex-col text-center">
                          <p className="text-xs text-gray-500 mb-1">
                            {items.profession}
                          </p>
                          <p className="text-base font-semibold mb-2">
                            {items.name}
                          </p>

                          <p className="text-xs leading-relaxed text-gray-700 flex-1">
                            {items.detail}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* FAQ Section on Home Page */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600 mt-3">
              Quick answers to common questions
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-white border border-gray-200 rounded-2xl px-3 py-3 cursor-pointer hover:shadow-md transition-all"
              >
                <summary className="flex justify-between items-center text-lg font-medium text-gray-900 list-none">
                  {faq.q}
                  <span className="text-2xl text-gray-400 group-open:rotate-45 transition-transform">
                    +
                  </span>
                </summary>
                <p className="text-gray-600 mt-4 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>

          <div className="text-center mt-10">
            <button
              onClick={() => navigate("/faq")}
              className="text-[#35A93E] font-medium hover:underline"
            >
              View All FAQs →
            </button>
          </div>
        </div>
      </div>

      {/* ================= Contact CTA ================= */}
      <section className="py-16 bg-[#35A93E] text-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold">
            Have Questions? Let's Talk.
          </h2>

          <p className="mt-4 text-green-100 max-w-2xl mx-auto leading-7">
            Our team is here to help you with memberships, healthcare services,
            partnerships, and any questions about LifeOnPlus. We'd love to hear
            from you.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 bg-white text-[#35A93E] px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition"
          >
            Contact Us
          </button>
        </div>
      </section>

      {/* Products */}
      {/* <div className="max-w-screen-2xl mx-auto py-12 px-4">
        <h2 className="text-xl sm:text-xl md:text-3xl lg:text-4xl font-semibold mb-6 md:mb-8">
          Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {products.map((product) => {
            return (
              <div
                key={product._id}
                onClick={() =>
                  navigate(`/product-details/${product._id}`, {
                    state: {
                      product,
                      category: product.categoryId,
                      subCategory: product.subCategoryId || null,
                      subSubCategory: product.subSubCategoryId || null,
                      subSubSubCategory: product.subSubSubCategoryId || null,
                    },
                  })
                }
                className="border rounded-lg p-4 cursor-pointer hover:shadow-lg"
              >
                <img
                  src={
                    product?.variations?.[0]?.images?.[0] ||
                    product?.images?.[0]
                  }
                  className="h-[160px] w-full object-contain mb-3"
                />
                <h3 className="text-sm font-medium">{product.productName}</h3>
                <p className="text-sm text-gray-600">
                  {getCurrencySymbol()}
                  {convertPrice(
                    product?.price?.amount ||
                      product?.variations?.[0]?.price?.amount,
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div> */}

      {/* Vendor Products */}
      {/* <div className="max-w-screen-2xl mx-auto py-12 px-4">
        <h2 className="text-4xl text-center underline text-[#47b250] font-semibold mb-8">
          Health Care Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {vendorProduct.map((product) => {
            return (
              <div
                key={product._id}
                onClick={() =>
                  navigate(`/vendor-product-details/${product._id}`)
                }
                className="border rounded-lg p-4 cursor-pointer hover:shadow-lg"
              >
                <img
                  src={product?.images?.[0]}
                  className="h-[160px] w-full object-contain mb-3"
                />
                <h3 className="text-sm font-medium">{product.productName}</h3>
                <p className="text-sm text-gray-600">
                  {getCurrencySymbol()}
                  {convertPrice(product?.variations?.[0]?.price?.amount)}
                </p>
              </div>
            );
          })}
        </div>
      </div> */}
    </>
  );
};

export default Home;
